export function PictureAsset({
  source = "",
  ext = "",
  alt = "",
  className = "",
  wrapperClassName = "",
}: {
  source: string;
  ext: string;
  alt: string;
  className?: string;
  wrapperClassName?: string;
}) {
  const imageSrc = source ? `${source}.${ext}` : "";
  const avifSrc = source ? `${source}.avif` : "";

  return (
    <picture className={wrapperClassName}>
      {avifSrc && <source srcSet={avifSrc} type="image/avif" />}
      {imageSrc && <source srcSet={imageSrc} type={`image/${ext}`} />}
      <img alt={alt} className={className} />
    </picture>
  );
}
